import AjvModule from "ajv";
import DatabaseEventsSchema from "./events.json" with { type: "json" };
// FIXME: https://github.com/ajv-validator/ajv/issues/2047
const Ajv = AjvModule.default;
export class AjvEventsValidator {
    validator;
    constructor() {
        const ajv = new Ajv({
            allowUnionTypes: true,
            verbose: true,
        });
        this.validator = ajv.compile(DatabaseEventsSchema);
    }
    validateEvents(events) {
        const isValidTypes = this.validator(events);
        if (isValidTypes !== true) {
            if (this.validator.errors) {
                return {
                    errors: this.validator.errors.map((error) => ({
                        message: `${error.schemaPath} ${error.message}`,
                    })),
                };
            }
            else {
                return {
                    errors: [{ message: "An unknown validation error occurred" }],
                };
            }
        }
        // TODO: validate the existence of IDs
        return true;
    }
}
//# sourceMappingURL=AjvEventsValidator.js.map